import { Telemetry,ValidTelemetryEvent } from '~commonInfra/services/Telemetry';

// Event name has to match what appears in the database
export enum RequestAccessTelemetryEvents {
  Displayed = 'request_access_displayed',
  Clicked = 'request_access_clicked',
  GrantAccessDialog = 'grant_access_clicked',
  GrantAccessEmail = 'grant_access_email_clicked',
  ManagePermissions = 'manage_permissions_clicked',
}

export interface RequestAccessDisplayedEvent extends ValidTelemetryEvent {
  type: RequestAccessTelemetryEvents.Displayed;
  content_type: string;
}

export interface RequestAccessClickedEvent extends ValidTelemetryEvent {
  type: RequestAccessTelemetryEvents.Clicked;
  content_type: string;
}

export interface GrantAccessDialogClickedEvent extends ValidTelemetryEvent {
  type: RequestAccessTelemetryEvents.GrantAccessDialog;
  content_type: string;
}

export interface GrantAccessEmailClickedEvent extends ValidTelemetryEvent {
  type: RequestAccessTelemetryEvents.GrantAccessEmail;
  content_type: string;
}

export interface ManagePermissionsClickedEvent extends ValidTelemetryEvent {
  type: RequestAccessTelemetryEvents.ManagePermissions;
  content_type: string;
}

export function sendRequestAccessDisplayedTelemetry(contentType: string) {
  Telemetry.sendEvent<RequestAccessDisplayedEvent>({
    type: RequestAccessTelemetryEvents.Displayed,
    content_type: contentType
  });
}

export function sendRequestAccessClickedTelemetry(contentType: string) {
  Telemetry.sendEvent<RequestAccessClickedEvent>({
    type: RequestAccessTelemetryEvents.Clicked,
    content_type: contentType
  });
}

export function sendGrantAccessDialogClickedTelemetry(contentType: string) {
  Telemetry.sendEvent<GrantAccessDialogClickedEvent>({
    type: RequestAccessTelemetryEvents.GrantAccessDialog,
    content_type: contentType
  });
}

export function sendManagePermissionsClickedTelemetry(contentType: string) {
  Telemetry.sendEvent<ManagePermissionsClickedEvent>({
    type: RequestAccessTelemetryEvents.ManagePermissions,
    content_type: contentType
  });
}

export function sendGrantAccessEmailClickedTelemetry(contentType: string) {
  Telemetry.sendEvent<GrantAccessEmailClickedEvent>({
    type: RequestAccessTelemetryEvents.GrantAccessEmail,
    content_type: contentType
  });
}
